class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      // we update cart drawer with every element except for the fresh relevance section
      if (section.id === 'cart-drawer') {
        let tmp = document.createElement('div');
        let newInnerHtml = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        tmp.innerHTML = newInnerHtml;

        let wrapper = tmp.querySelector('.drawer__inner');
        let deepElementToReplace = elementToReplace.querySelector('.drawer__inner');

        const freshRelevanceIndexInWrapper = Array.from(wrapper.children).findIndex(
          (el) => el.id === 'cart-fresh-relevance',
        );
        const childrenBeforeFreshRelevance = Array.from(wrapper.children).slice(0, freshRelevanceIndexInWrapper);
        const childrenAfterFreshRelevance = Array.from(wrapper.children).slice(freshRelevanceIndexInWrapper + 1);

        // delete all children of elementToReplace without id cart-fresh-relevance
        let childrenToDelete = Array.from(deepElementToReplace.children).filter(
          (el) => el.id !== 'cart-fresh-relevance',
        );
        childrenToDelete.forEach((el) => {
          deepElementToReplace.removeChild(el);
        });

        // add new before
        childrenBeforeFreshRelevance.reverse().forEach((el) => {
          deepElementToReplace.insertBefore(el, deepElementToReplace.firstChild);
        });

        // add new after
        childrenAfterFreshRelevance.forEach((el) => {
          deepElementToReplace.appendChild(el);
        });

        const imboxBoxes = deepElementToReplace.querySelectorAll('.imbox-drawer-button');

        imboxBoxes.forEach((box) => {
          box.addEventListener('click', (event) => {
            const description = deepElementToReplace.querySelector('[data-paragraph="' + box.dataset.parentid + '"]');
            if (description.style.display === 'block') {
              description.style.display = 'none';
            } else {
              description.style.display = 'block';
            }
          });
        });
      } else {
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
